export default __webpack_public_path__ + "static/media/search-bg.8ac80c55.webp";